var scope_0 = require('/home/runner/work/graphql-platform/graphql-platform/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e62e4d0d8c5702c254d0741eaa91d90.js').default;
var scope_1 = require('/home/runner/work/graphql-platform/graphql-platform/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ddb8f1aea2ab189ff2a3bd5a67f7a03.js').default;
var scope_2 = require('/home/runner/work/graphql-platform/graphql-platform/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7206032b394a8220312dddcb7fc4877e.js').default;
var scope_3 = require('/home/runner/work/graphql-platform/graphql-platform/website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    